module.exports = __webpack_public_path__ + "media/images/features/wedding-ceremony-cost/img_cost-2215a76b093cab015363abd179f55959.svg";